
/*
*@example vm.tool.image.changeSize('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQf6CWT1EDhkRThSvxjz70CvwFFtj4TbS8WIIclsxzn10Lev10u', 64)
*/
class ImageTool {
  /*
  * 改变图片大小
  * @param {String} imgUrl 图片路径地址
       {String} size 改变后的图片大小，单位b。（并不精确，但误差一般不会超过一个数量级）
  * @return {String} base64
  */
  compressImg (imgUrl, size) {
    let img = new Image()
    img.src = imgUrl
    img.crossOrigin = 'Anonymous'
    img.onload = function () {
      let width = img.width
      let height = img.height
      let imgSize = width * height
      let rate = size / imgSize
      // canvas = document.createElement('canvas'),
      let canvas = document.createElement('canvas')
      let contest = canvas.getContext('2d')

      canvas.width = width
      canvas.height = height
      contest.drawImage(img, 0, 0, width, height)
      let base64 = canvas.toDataURL('image/jpeg', rate)
      return base64
    }
  }

  /**
  *  将图片转为base64格式
  * @params {File} file 文件对象
  * @return {Promise} 回调参数: {String} base64文件
  */
  toBase64 (imgUrl) {
    let img = new Image()
    img.src = imgUrl
    return new Promise((resolve, reject) => {
      img.onload = function () {
        let width = img.width
        let height = img.height
        let canvas = document.createElement('canvas')
        let contest = canvas.getContext('2d')

        canvas.width = width
        canvas.height = height
        contest.drawImage(img, 0, 0, width, height)
        resolve(canvas.toDataURL('image/jpeg'))
      }
    })
  }

  /**
  *  根据图片文件获取路径
  * @params {File} file 文件对象
  * @return {Promise} 回调参数: {String} path 路径
  */
  getPath (file) {
    let reader = new FileReader()
    return new Promise((resolve, reject) => {
      reader.onload = (e) => {
        resolve(e.currentTarget.result)
      }
      reader.readAsDataURL(file)
    })
  }
}
export default new ImageTool()
